import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FailedPaymentsService } from '../../billing/failed-payments/failed-payments.service';

/** replace with glxy-alert */
@Component({
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  selector: 'app-status-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent implements OnInit {
  @Input() statusText: string;
  @Input() type: string;
  @Input() border = true;
  @Input() actionTitle: string;
  @Input() actionCallback: () => void;
  @Input() buttonType = 'link';
  private styleMaps = {
    info: {
      icon: 'info outline',
      type: 'info',
    },
    'warn-soft': {
      icon: 'info outline',
      type: 'warn',
    },
    warn: {
      icon: 'warning',
      type: 'warn',
    },
    error: {
      icon: 'warning',
      type: 'error',
    },
    'billing-error': {
      icon: 'lock',
      type: 'error',
    },
  };
  icon: string;

  constructor(private failedPaymentsService: FailedPaymentsService) {}

  ngOnInit(): void {
    this.icon = this.styleMaps[this.type].icon;
    this.type = this.styleMaps[this.type].type;
    if (!this.buttonType) {
      this.buttonType = 'link';
    }
  }
}
